const $       = require('jquery');
const tpl     = require('../util/template');
const eventer = require('../util/eventer');

function Slider(opts) {
  let api = eventer({});

  let elem = $(`
    <slider class="wrfont ${opts.klass}">
      ${tpl.if(opts.label, () => `
        <span>${opts.label}</span>
      `)}
      <div class="slider-wrap">
        <div class="slider-track">
          <div class="slider-fill"></div>
          <div class="slider-thumb">
            <div class="focus-ring"></div>
            <div class="thumb-ring"></div>
          </div>
        </div>
      </div>
      ${tpl.if(opts.valueStr, () => `
        <div class="slider-value"></div>
      `)}
    </slider>
  `).contextmenu(false);

  let min, max, value;
  let ticking, touching;
  let sliderTrack = elem.find('.slider-track');
  let sliderThumb = elem.find('.slider-thumb');
  let sliderFill = elem.find('.slider-fill');

  function init() {
    value = min = isNaN(opts.min) ? 1 : opts.min;
    max = isNaN(opts.max) ? 100 : opts.max;
    if (opts.klass) {
      elem.addClass(opts.klass);
    }
    elem.appendTo(opts.container);
    update();
  }

  function setValue(val) {
    if (touching) return;
    value = val;
    update();
  }

  function update() {
    let percent = valueToPercent(value);
    let percentStr = (percent * 100) + '%';
    sliderThumb[0].style.left = percentStr;
    sliderFill[0].style.width = percentStr;
    if (opts.valueStr) {
      elem.find('.slider-value').html(opts.valueStr(value, percent));
    }
  }

  function setSliderFromInput(e) {
    if (!touching) return;
    value = percentToValue(positionToPercent(e.srcEvent.pageX));
    setSliderPercent(true);
  }

  function setSliderPercent(emit) {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
      if (emit) api.trigger('slide', [value]);
    });
  }

  function positionToPercent(x) {
    let dim = sliderTrack[0].getBoundingClientRect();
    return Math.max(0, Math.min(1, (x - dim.left) / (dim.width)));
  }

  function percentToValue(percent) {
    return (min + percent * (max - min));
  }

  function valueToPercent(val) {
    val = Math.max(Math.min(val, opts.max), opts.min);
    return (val - min) / (max - min);
  }

  api.set = setValue;
  api.get = () => value;

  init();

  return api;
}

module.exports = Slider;
